export default __webpack_public_path__ + "static/media/referral-1.639f12f5.png";